'use strict';

module.exports.lego_on_react = '3.1.0';
module.exports.islands = '5.29.0';
